import type { StartParamIntent } from '@cradle7/shared';

/**
 * Pure parser for Telegram's `start_param`. The TG WebApp passes whatever was
 * after `?startapp=` in the deep-link URL. Returns a discriminated union the
 * boot logic can dispatch on.
 */
export function parseStartParam(raw: string | undefined): StartParamIntent {
  if (!raw) return { kind: 'none' };
  if (raw === 'daily') return { kind: 'daily' };
  const m = raw.match(/^challenge-(\d+)$/);
  if (m) {
    const seed = Number(m[1]);
    if (Number.isInteger(seed) && seed >= 0) {
      return { kind: 'challenge', seed };
    }
  }
  return { kind: 'unknown', raw };
}
